import {
  LOGIN,
  LOGIN_PAGE_UNLOADED,
  ASYNC_START,
  UPDATE_FIELD_AUTH,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  VERIFY_PIN_CODE_UNLOADED
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        inProgress: false,
        userKey: action.error ? null : action.payload.user_key,
        phone: action.error ? null : action.payload.phone,
        errors: action.error ? action.payload.error : null
      };
    case LOGIN_PAGE_VERIFY_PIN_CODE:
      return {
        ...state,
        errors: action.error ? action.payload.error : null
      };
    case LOGIN_PAGE_UNLOADED:
    case VERIFY_PIN_CODE_UNLOADED:
      return {};
    case ASYNC_START:
      if (action.subtype === LOGIN || action.subtype === LOGIN_PAGE_VERIFY_PIN_CODE) {
        return { ...state, inProgress: true };
      }
      break;
    case UPDATE_FIELD_AUTH:
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js